import { useQuery } from '@tanstack/react-query';
import { RollCompetitionsEntriesQueryKeys } from '../../queryKey';
import { GenericError } from '@/models/generic-error';
import { AxiosError } from 'axios';
import { fetchRollCompetitionEntriesWithPlace } from './service';
import { useState } from 'react';
import { PaginatedResponse } from '@starsoft/common/models';
import {
  UseRollCompetitionEntriesProps,
  UseRollCompetitionEntriesQueryKeyProps,
} from './props';
import { usePaginatedQuery } from '@starsoft/common/hooks';
import { RollCompetitionEntriesRequestDto } from '@/services/dto/roll-competition-entries/roll-competition-entries-request.dto';
import { RollCompetitionEntryWithPlaceAndPrize } from '@/models/roll-competition/entries/with-place/inde';
import { parseToBigInt } from '@starsoft/common/utils/parsers';

export function useRollCompetitionEntriesByCycleId({
  cycleId,
}: UseRollCompetitionEntriesProps) {
  const [page, setPage] = useState<number>(1);

  const filter: RollCompetitionEntriesRequestDto = {
    page,
    limit: 10,
    cycleId: parseToBigInt(cycleId) as bigint,
  };

  const queryKey: UseRollCompetitionEntriesQueryKeyProps = [
    RollCompetitionsEntriesQueryKeys.Primary,
    filter,
  ];

  const { isPending, fetchStatus, data, error, refetch, isFetching } = useQuery<
    PaginatedResponse<RollCompetitionEntryWithPlaceAndPrize>,
    AxiosError<GenericError>,
    PaginatedResponse<RollCompetitionEntryWithPlaceAndPrize>,
    UseRollCompetitionEntriesQueryKeyProps
  >({
    queryKey,
    queryFn: fetchRollCompetitionEntriesWithPlace,
    staleTime: 5 * 1000,
    enabled: !!cycleId,
  });

  const paginatedQueryCallbacks = usePaginatedQuery({
    data,
    page,
    setPage,
  });

  return {
    isPending: isPending && fetchStatus !== 'idle',
    rollCompetitionEntries: data,
    error,
    refetch,
    isFetching,
    ...paginatedQueryCallbacks,
    page,
  };
}
